import { render, staticRenderFns } from "./ShineSlider.vue?vue&type=template&id=40d41b41&scoped=true"
import script from "./ShineSlider.vue?vue&type=script&lang=js"
export * from "./ShineSlider.vue?vue&type=script&lang=js"
import style0 from "./ShineSlider.vue?vue&type=style&index=0&id=40d41b41&prod&lang=scss&scoped=true"
import style1 from "./ShineSlider.vue?vue&type=style&index=1&id=40d41b41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d41b41",
  null
  
)

export default component.exports